import * as THREE from "three";

interface Props {
    color: string
    bgColor: string
}
const BaseLines = (props:Props) => {
    const rf = new THREE.Shape()
        .moveTo(44.5/12, 44.5/12)
        .lineTo(90, 90)
        .lineTo(90 -(4/12), 90)
        .lineTo((44.5-4)/12, (44.5)/12)
        .lineTo(44.5/12, 44.5/12)
    const lf = new THREE.Shape()
        .moveTo(-44.5/12, 44.5/12)
        .lineTo(-90, 90)
        .lineTo(-90 +(4/12), 90)
        .lineTo((-44.5+4)/12, (44.5)/12)
        .lineTo(-44.5/12, 44.5/12)

  return (
    <>
    <mesh position={[0,0,0]} rotation={[0,0,0]}>
        <shapeGeometry args={[rf]} />
        <meshBasicMaterial color={props.color} />
    </mesh>
    <mesh position={[0,0,0]} rotation={[0,0,0]}>
        <shapeGeometry args={[lf]} />
        <meshBasicMaterial color={props.color} />
    </mesh>
    </>
  )
}

export default BaseLines